import styled from 'styled-components/macro';
import { Col, Row } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';
const {
  media_md,
  media_lg,
  spacing,
  spacing_lg,
  spacing_sm,
  custom_border_grey
} = variables;

export const Wrapper = styled('div')`
  h1 {
    margin-bottom: 40px;
  }
  .attribute-description {
    display: none;
  }
  .title-description {
    margin: ${spacing_sm} 0 ${spacing_lg};
    max-width: 900px;
    white-space: pre-wrap;
  }
  @media (min-width: 900px) {
    h1 {
      margin-bottom: 40px;
    }
    .attribute-description {
      display: block;
    }
    .title-description {
      display: none;
    }
  }
`

export const OrWrapper = styled('div')`
  position: relative;
  :after {
    content: "";
    height: 1px;
    position: absolute;
    left: 0;
    right: 0;
    border-bottom: 1px solid #e4e4e4;
    top: 27px;
    z-index: 0;
  }
  h3 {
    background: #fff;
    z-index: 3;
    position: relative;
    width: 73px;
    margin: 0 auto;
  }
`

export const ImageGalleryWrapper = styled('div')`
  margin: 0px auto 60px;
  @media (min-width: 900px) {
    margin: 0 30px 0 0;
  }
`

export const AttributesCol = styled('div')`
  min-width: 100%;
  @media (min-width: 900px) {
    width: auto;
    min-width: 300px;
    flex: 1;
  } 
`

export const LeftColumn = styled(Col)`
  width: 100%;
  max-width: 100%;
  @media (min-width: 1100px) {
    padding-right: 30px;
  } 
`

export const RightColumn = styled(Col)`
  width: 100%;
  margin-top: ${spacing};
  @media (min-width: 970px) {
    margin-top: 0;
    width: auto;
    max-width: 290px;
  }
  @media (min-width: 1000px) {
    max-width: 310px;
  } 
  @media (min-width: 1200px) {
    max-width: 330px;
  } 
`

export const CtaHeader = styled('div')`
  display: none;
  @media ${media_md} {
    display: block;
  }
`

export const AttributeWrapper = styled(Col)`
  margin-bottom: 30px;
  padding-right: 20px;
  &:last-child {
    * {
      border: none !important;
      padding-right: 0 !important;
    }
  }
`

export const Attribute = styled('div')`
  padding-right: 30px;
  min-width: 105px;
  //border-right: 1px solid ${custom_border_grey};
`



export const AttributeRow = styled(Row)`
  max-width: 1000px; 
`